// GSM 03.38 default alphabet plus the single-shift extension table.
// A message that contains any other character is sent as UCS-2.
// https://www.twilio.com/docs/glossary/what-is-gsm-7-character-encoding
const GSM7_CHARACTERS = new Set([
  '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ\u001bÆæßÉ',
  ' !"#¤%&\'()*+,-./0123456789:;<=>?',
  '¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿',
  'abcdefghijklmnopqrstuvwxyzäöñüà',
  '\f^{}\\[~]|€',
].join(''))

export const SMS_RECOMMENDED_LENGTH = 320
export const SMS_UCS2_WARNING_LENGTH = 670
export const SMS_TWILIO_LIMIT = 1600

export const SMS_LENGTH_STATUS_MESSAGES = {
  success: 'This SMS is expected to be within the recommended Twilio length of 320 characters and should perform well.',
  warning: 'This SMS is using UCS-2 encoding, it is expected to be longer than 670 characters and might not be delivered properly.',
  error: "This SMS is expected to be longer than Twilio's limit of 1600 characters and likely will not get delivered properly.",
}

// Same filled circles the rest of the app uses for ok / warning / error.
export const SMS_LENGTH_STATUS_ICONS = {
  success: 'statusOk',
  warning: 'statusWarning',
  error: 'statusError',
}

// Public: True when the text cannot be sent with GSM-7 and Twilio will use UCS-2.
export function smsUsesUcs2 (text) {
  if (text == null || typeof text === 'boolean') return false
  for (const character of String(text)) {
    if (!GSM7_CHARACTERS.has(character)) return true
  }
  return false
}

function smsTextLength (text) {
  if (text == null || typeof text === 'boolean') return 0
  return String(text).length
}

// Public: Length badge for an SMS field.
//
// - error: longer than Twilio's 1600-character limit
// - warning: UCS-2 and longer than 670
// - success: 320 characters or fewer (including empty)
// - null: GSM-7 from 321 to 1600, or UCS-2 from 321 to 670
export function smsLengthStatus (text) {
  const length = smsTextLength(text)
  if (length > SMS_TWILIO_LIMIT) return 'error'
  if (smsUsesUcs2(text) && length > SMS_UCS2_WARNING_LENGTH) return 'warning'
  if (length <= SMS_RECOMMENDED_LENGTH) return 'success'
  return null
}
